export default __webpack_public_path__ + "b32d09e819cbb7e84fa1a4210fefd17f.png";